import * as React from 'react';

import { AviaPassengerFareFragment, FareFamilyFragment } from '@websky/graphql';
import { MoneyType } from '../../../PriceMatrix/types';
import { useToggleable } from '../../../hooks';
import { useRenderers } from '../../../renderProps';
import { ModalX } from '../../../BaseComponents';
import CompareFares from '../../../CompareFares/components/CompareFares/CompareFares';
import FareConditionsModal from '../../../FareConditions/components/Component';
import { FareFfpBonusInfo } from '@entities/fare';
import { FareGroup as FareGroupDefault } from '@features/fares';

interface Props {
	className?: string;
	fare: FareFamilyFragment;
	passengerFares?: AviaPassengerFareFragment[];
	flightId: string;
	price: MoneyType;
	orderId?: string;
	hideConditionsButton?: boolean;
	isFareRulesDisabled?: boolean;
	ffpBonusInfo?: FareFfpBonusInfo;
}

const SelectedFareGroup: React.FC<Props> = ({
	className,
	fare,
	passengerFares,
	flightId,
	price,
	orderId,
	hideConditionsButton,
	ffpBonusInfo,
	isFareRulesDisabled
}) => {
	const { FareGroup = FareGroupDefault } = useRenderers();

	const { isOpen: isFareCompareOpen, open: openFareCompare, close: closeFareCompare } = useToggleable(false);
	const { isOpen: isFareConditionsOpen, open: openFareConditions, close: closeFareConditions } = useToggleable(false);

	return (
		<>
			<FareGroup
				className={className}
				fare={fare}
				price={price}
				passengerFares={passengerFares}
				ffpBonusInfo={ffpBonusInfo}
				onClickRules={openFareConditions}
				isFareRulesDisabled={isFareRulesDisabled}
				onClickConditions={!hideConditionsButton && openFareCompare}
				showUnavailableOptions
				selected
			/>

			<ModalX isOpen={isFareCompareOpen} noPadding={true} size="xlarge" onClose={closeFareCompare} scroll="body">
				<CompareFares selectedFareName={fare.title} orderId={orderId} />
			</ModalX>

			<FareConditionsModal
				flightId={flightId}
				orderId={orderId}
				isOpen={isFareConditionsOpen}
				onClose={closeFareConditions}
			/>
		</>
	);
};

export default SelectedFareGroup;
